module.exports = __webpack_public_path__ + "static/img/amazon-wordmark.96691c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amazon-wordmark.png
// module id = 611
// module chunks = 2